export enum InspectionResultEnum {
    CORRECT_PROCEDURE = 'CorrectProcedure', // Đúng quy trình
    MISSING_STEP = 'MissingStep', // Thiếu bước
    INCORRECT_OPERATION = 'IncorrectOperation', // Sai thao tác
}
